import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@ncoder/ui";
import { ErrorAnalysisForm } from "@/components/molecules/modernise-with-ai/ErrorAnalysisForm";

interface ErrorAnalysisModalProps {
  open: boolean;
  onClose: () => void;
  errorFile: File | null;
  onFileSelect: (file: File | null) => void;
  onSubmit: () => void;
}

export const ErrorAnalysisModal: React.FC<ErrorAnalysisModalProps> = ({
  open,
  onClose,
  errorFile,
  onFileSelect,
  onSubmit,
}) => (
  <Dialog open={open} onOpenChange={onClose}>
    <DialogContent className="sm:max-w-[500px]">
      <DialogHeader>
        <DialogTitle>Salesforce Error Analysis</DialogTitle>
        <DialogDescription>
          Upload your Salesforce error email or document for AI analysis
        </DialogDescription>
      </DialogHeader>

      <ErrorAnalysisForm errorFile={errorFile} onFileSelect={onFileSelect} />

      <div className="flex justify-end gap-2 mt-4">
        <Button variant="outline" onClick={onClose}>
          Cancel
        </Button>
        <Button onClick={onSubmit} disabled={!errorFile}>
          Analyze Error
        </Button>
      </div>
    </DialogContent>
  </Dialog>
);
